export const theme = {
  colors: {
    turquioze: "#1DB097",
    pink: "#E11452",
  },
};
